/* eslint-disable max-lines */
import { css } from 'linaria';

export const specialOfferModal = css`
  &&& {
    @media (--only-largeDesktop) {
      width: 1180px;
    }

    @media (--only-desktop) {
      width: 940px;
    }

    @media (--only-tablet) {
      width: 660px;
    }

    @media (--from-tablet) {
      max-width: unset;
    }

    @media (--only-mobile) {
      max-width: 450px;
    }
  }
`;

export const specialOfferModalCloseButton = css`
  &&& {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 10;

    @media (--to-desktop) {
      top: 8px;
      right: 8px;
      color: var(--text-primary-invert);
      background-color: rgb(0 0 0 / 60%);
    }

    @media (--only-tablet) {
      width: 40px;
      height: 40px;
    }
  }
`;

export const specialOfferModalContent = css`
  display: flex;
  background-color: var(--background-secondary);
  border-radius: var(--rounding-l);

  @media (--to-desktop) {
    flex-direction: column;
    height: 100%;
  }

  @media (width <= 375px) {
    border-radius: unset;
  }
`;

export const specialOfferModalImage = css`
  object-fit: cover;
  width: 474px;
  height: 100%;

  @media (--only-desktop) {
    width: 292px;
  }

  @media (--from-desktop) {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: var(--rounding-l) 0 0 var(--rounding-l);
    object-position: left;
  }

  @media (--only-tablet) {
    width: 100%;
    border-radius: var(--rounding-l) var(--rounding-l) 0 0;
  }

  @media (--only-mobile) {
    width: 100%;
  }
`;

export const specialOfferModalImageWrapper = css`
  @media (--only-tablet) {
    height: 216px;
  }

  @media (--only-mobile) {
    height: 116px;
  }
`;

export const specialOfferModalBodyWrapper = css`
  display: flex;
  flex-direction: column;
  width: 707px;
  padding: 32px;
  margin-left: 474px;
  overflow-x: hidden;
  overflow-y: auto;

  @media (--only-desktop) {
    width: 648px;
    margin-left: 292px;
  }

  @media (--to-desktop) {
    width: 100%;
    margin-left: 0;
  }

  @media (--only-mobile) {
    padding: 24px;
  }
`;

export const specialOfferModalBody = css`
  width: 577px;

  @media (--only-desktop) {
    width: 528px;
  }

  @media (--to-desktop) {
    width: 100%;
  }
`;

export const specialOfferModalTitle = css`
  margin-bottom: 8px;
`;

export const specialOfferModalSubTitle = css`
  display: block;
  margin-bottom: 8px;
  white-space: pre-line;

  @media (--only-mobile) {
    margin-bottom: 4px;
  }
`;

export const specialOfferModalOptionList = css`
  padding: 0;
  margin: 0;

  li {
    display: flex;
    align-items: baseline;
    margin-bottom: 8px;
    column-gap: 10px;

    @media (--only-mobile) {
      margin-bottom: 4px;
    }

    li::before {
      color: var(--text-primary);
    }
  }
`;

export const specialOfferModalOptionMarkerTypeMap: Record<string, string> = {
  disc: css`
    li {
      align-items: flex-start;

      &::before {
        font-weight: 900;
        font-size: 30px;
        line-height: 8px;
        content: '.';

        @media (--only-mobile) {
          font-size: 25px;
        }
      }
    }
  `,
  decimal: css`
    li {
      counter-increment: custom-counter;

      &::before {
        content: counter(custom-counter) '.';
        font-size: 16px;

        @media (--only-mobile) {
          font-size: 14px;
        }
      }
    }
  `,
};

export const specialOfferModalText = css`
  a {
    text-decoration: none;
    color: var(--control-hover-accent);
  }

  b {
    font-weight: 500;
  }

  a:active,
  a:hover {
    color: var(--brand-dark);
  }
`;

export const specialOfferModalButton = css`
  margin-top: 16px;
`;

export const specialOfferModalDisclaimer = css`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  margin-top: 24px;

  @media (--only-mobile) {
    row-gap: 4px;
  }
`;

export const specialOfferModalDisclaimerText = css`
  white-space: pre-line;

  @media (--only-mobile) {
    font-size: 12px;
    line-height: 16px;
  }

  a {
    color: var(--text-minor);
  }

  a:active,
  a:hover {
    color: var(--text-minor);
  }
`;
